import React from "react";

export const OTPInput = ({ pin }) => {
  const pinNumberInArray = ["", "", "", "", "", ""];

  for (let i = 0; i < 6; ++i) {
    pinNumberInArray[i] = pin[i];
  }

  return (
    <div className="d-flex flex-row justify-content-center">
      {pinNumberInArray.map((x, index) => (
        <div key={"div" + index}>
          <p
            className={
              (x === undefined && pinNumberInArray[index - 1] !== undefined) ||
              (index === 0 && pinNumberInArray[0] === undefined)
                ? "m-2 glowing-input otp-input "
                : "m-2 bg-light border otp-input"
            }
            key={"text" + index}
          >
            {x}
          </p>
        </div>
      ))}
    </div>
  );
};
